import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const Wrapper = styled.div`
  margin-bottom: 16px;
`;

export const BlurbText = styled.div<{ showAll: boolean }>`
  font-size: 16px;
  line-height: 24px;
  color: #333f48;

  display: -webkit-box;
  line-height: normal;
  -webkit-box-orient: vertical;
  overflow: ${(props) => (props.showAll ? 'inherit' : 'hidden')};
  -webkit-line-clamp: ${(props) => (props.showAll ? 'unset' : 4)};

  @media (${mediaQuery.tablet}) {
    -webkit-line-clamp: ${(props) => (props.showAll ? 'unset' : 3)};
  }
`;

export const ShowMoreButton = styled.a`
  margin-top: 8px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`;
